import axios from 'axios';

export default () => {
  const promise = new Promise((resolve, reject) => {
    axios
      .get(
        `${process.env.VUE_APP_API_ADMIN_LOCATION}users/list?roles=sales,admin,superadmin,organization_admin,organization_superadmin`
      )
      .then((res) => {
        resolve(res.data);
      })
      .catch((error) => {
        reject(error);
      });
  });

  return promise;
};
